import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LandingPage from "./LandingPage";
import Flyer from "./components/Flyer";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/flyer" element={<Flyer />} />
      </Routes>
    </BrowserRouter>
  );
};
//test
export default App;
